export const aawzDrive = {
  /**
   * Base para buscar os aquivos utilizando como Profissional
   * @param {String} id_cliente_app id do cliente
   */
  baseProfissionalUrl({ id_cliente_app } = {}) {
    return `/v3/api/aawz-drive/clients/${id_cliente_app}/drive`
  },

  /**
   * Base para buscar os aquivos do escritorio (sem vínculo de cliente)
   */
  baseOfficeUrl({ id_cliente_app = null } = {}) {
    return id_cliente_app
      ? `/v3/api/aawz-drive/office/${id_cliente_app}/drive`
      : '/v3/api/aawz-drive/office/drive'
  },

  /**
   * @method GET Listar os arquivos do escritorio cadastrados
   * @param {String} id_cliente_app id do cliente
   * @param {String} drive_root_name nome da raiz do drive (É como o backend vai retornar o nome da pasta raiz)
   */
  professionalGetFiles({ id_cliente_app, drive_root_name = 'AAWZ Drive' }) {
    return `${this.baseProfissionalUrl({
      id_cliente_app,
    })}?root_name=${drive_root_name}`
  },

  /**
   * @method GET Listar os arquivos do escritorio (id_cliente = null)
   * @param {String} drive_root_name nome da raiz do drive (É como o backend vai retornar o nome da pasta raiz)
   */
  officeGetFiles({ drive_root_name = 'AAWZ Drive' } = {}) {
    return `${this.baseOfficeUrl()}?root_name=${drive_root_name}`
  },

  /**
   * @method POST Upload de arquivos
   * @param {String} id_cliente_app id do cliente
   */
  professionalUploadFile({ id_cliente_app }) {
    return `${this.baseProfissionalUrl({ id_cliente_app })}`
  },

  /**
   * @method POST Upload de arquivos (escritorio)
   */
  officeUploadFile() {
    return `${this.baseOfficeUrl()}`
  },

  /**
   * @method POST Criar pasta
   * @param {String} id_cliente_app id do cliente
   */
  professionalCreateFolder({ id_cliente_app }) {
    return `${this.baseProfissionalUrl({ id_cliente_app })}`
  },

  /**
   * @method POST Criar pasta (escritorio)
   */
  officeCreateFolder() {
    return `${this.baseOfficeUrl()}`
  },

  /**
   * @method GET Baixar arquivo
   * @param {String} id_cliente_app id do cliente
   * @param {String} drive_file_id id do arquivo
   */
  professionalDownloadFile({ id_cliente_app, drive_file_id }) {
    return `${this.baseProfissionalUrl({
      id_cliente_app,
    })}/${drive_file_id}/download`
  },

  /**
   * @method GET Baixar arquivo (escritorio)
   * @param {String} drive_file_id id do arquivo
   */
  officeDownloadFile({ drive_file_id }) {
    return `${this.baseOfficeUrl()}/${drive_file_id}/download`
  },

  /**
   * @method POST Baixar multiplos itens (arquivo/pasta) em lote
   * @param {String} id_cliente_app id do cliente
   */
  professionalDownloadItems({ id_cliente_app }) {
    return `${this.baseProfissionalUrl({ id_cliente_app })}/download`
  },

  /**
   * @method POST Baixar multiplos itens (arquivo/pasta) em lote (escritorio)
   */
  officeDownloadItems() {
    return `${this.baseOfficeUrl()}/download`
  },

  /**
   * @method POST Excluir multiplos itens (arquivo/pasta) em lote
   * @param {String} id_cliente_app id do cliente
   */
  professionalDeleteItems({ id_cliente_app }) {
    return `${this.baseProfissionalUrl({ id_cliente_app })}/delete`
  },

  /**
   * @method POST Excluir multiplos itens (arquivo/pasta) em lote (escritorio)
   */
  officeDeleteItems() {
    return `${this.baseOfficeUrl()}/delete`
  },

  /**
   * @method PUT Atualizar multiplos itens (arquivo/pasta) em lote
   * @param {String} id_cliente_app id do cliente
   */
  professionalUpdateItems({ id_cliente_app }) {
    return `${this.baseProfissionalUrl({ id_cliente_app })}/update`
  },

  /**
   * @method PUT Atualizar multiplos itens (arquivo/pasta) em lote (escritorio)
   */
  officeUpdateItems() {
    return `${this.baseOfficeUrl()}/update`
  },

  /**
   * @method DELETE Excluir arquivo
   * @param {String} id_cliente_app id do cliente
   * @param {String} drive_item_id id do arquivo ou pasta
   */
  professionalDeleteFile({ id_cliente_app, drive_item_id }) {
    return `${this.baseProfissionalUrl({ id_cliente_app })}/${drive_item_id}`
  },

  /**
   * @method DELETE Excluir arquivo (escritorio)
   * @param {String} drive_item_id id do arquivo ou pasta
   */
  officeDeleteFile({ drive_item_id }) {
    return `${this.baseOfficeUrl()}/${drive_item_id}`
  },

  /**
   * @method PUT Renomear arquivo
   * @param {String} id_cliente_app id do cliente
   * @param {String} drive_item_id id do arquivo ou pasta
   */
  professionalRenameFile({ id_cliente_app, drive_item_id }) {
    return `${this.baseProfissionalUrl({ id_cliente_app })}/${drive_item_id}`
  },

  /**
   * @method PUT Renomear arquivo (escritorio)
   * @param {String} drive_item_id id do arquivo ou pasta
   */
  officeRenameFile({ drive_item_id }) {
    return `${this.baseOfficeUrl()}/${drive_item_id}`
  },

  /**
   * @method get Retorna as extensões de arquivos permitidas
   * @return {Object} { extensions: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png'] }
   */
  getAllowedExtensions: '/v3/api/aawz-drive/extensions',
}
